export default __webpack_public_path__ + "static/mmd-new-solid-f7fa0acf86c38f5092ffebb2d52ff1f0.svg";